export interface License {
  id: number
  package: string
  startDate: string
  endDate: string | null
  status: string
  created: string
  updated: string
}

export type Package = {
  value: string
  label: string
}

export const PACKAGE_LABELS: Record<string, string> = {
  'brp-hrworks-core': 'BRP @ HR WORKS Core',
  'brp-hrworks-pro-feedback': 'BRP @ HR WORKS Pro - Feedback',
  'brp-hrworks-pro-growth': 'BRP @ HR WORKS Pro - Growth',
  'brp-hrworks-pro-holistic': 'BRP @ HR WORKS Pro - Holistic',
  'brp-stand-alone-feedback': 'BRP Stand-alone Feedback',
  'brp-stand-alone-growth': 'BRP Stand-alone Growth',
  'brp-stand-alone-holistic': 'BRP Stand-alone Holistic',
}
